/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NEW_USER_MODERATION = "BAN" | "PREMOD" | "%future added value";
export type UserStatusChangeContainer_settings = {
    readonly organization: {
        readonly name: string;
    };
    readonly emailDomainModeration: ReadonlyArray<{
        readonly domain: string;
        readonly newUserModeration: NEW_USER_MODERATION;
    }>;
    readonly multisite: boolean;
    readonly " $refType": "UserStatusChangeContainer_settings";
};
export type UserStatusChangeContainer_settings$data = UserStatusChangeContainer_settings;
export type UserStatusChangeContainer_settings$key = {
    readonly " $data"?: UserStatusChangeContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"UserStatusChangeContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserStatusChangeContainer_settings",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "EmailDomain",
            "kind": "LinkedField",
            "name": "emailDomainModeration",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "domain",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "newUserModeration",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "multisite",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = '1e82f6539a454a57c0216d023c706673';
export default node;
